import React from "react";
import { drawPicker } from "../popovers/Picker";
import { getSignal } from "../App";
import Cookies from 'js-cookie';
import Button from "../ui/Button";
import { apiCall } from "../utils/Api";
import { showError } from "../ui/Message";
export default function StoreSelector(props) {

    const { controller = "" } = props;

    const session = window?.login_session || {};
    const path = window.location.pathname;
    const path_id = path.split("/")[1] ?? "";
    const stores = session?.available_corps?.filter(item => item.can_bmo).map(item => {
        return {
            value: item.id,
            label: item.name
        }
    }) || [];


    const logout = (_store_id = session.store_id) => {
        apiCall("account/logout", { store_id: _store_id }, (_s, _r) => {
            if (_s) {
                window.location.reload();
            } else {
                showError(_r);
            }
        })
    }


    const showStores = () => {
        drawPicker({
            controller: controller,
            value: parseInt(path_id), title: "Change location", description: <Button onClick={() => logout()} size="small" style={{ "width": "100%" }} type="primary">Logout</Button>, closeable: true, mask_close: true, route: window.bm_state.value, callback: (e) => {
                if (e) {
                    window.history.replaceState(null, '', '/' + e.toString());
                    Cookies.set("workstation", null, { expires: 14 })
                    window.location.reload();
                }
            }, offset: [0, 10],
            options: stores
        })
    }

    return (
        <>
            <strong className="text-light" style={{ "fontSize": "14px" }}>
                <a onClick={() => showStores()}>{window?.credentials?.store_name}▾</a>
            </strong>
        </>
    )

}